module.exports = __webpack_public_path__ + "static/img/LISBON_MAPLE.07ef4f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/LISBON_MAPLE.jpg
// module id = PqWe
// module chunks = 0